import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import {setMobileOverlayState} from '../../action/action'
import { connect } from 'react-redux'

class MobileKeyOverlay extends Component{
    constructor(props){
        super(props);
        
    }

    openSettings = (name="application_details") => {
        this.props.errorClose();
        if (window.cordova && window.cordova.plugins.settings) {
            console.log('openNativeSettingsTest is active');
            window.cordova.plugins.settings.open(name, function() {
                    console.log('opened settings');
                    this.setState({goBack:true});
                },
                function () {
                    console.log('failed to open settings');
                }
            );
        } else {
            console.log('openNativeSettingsTest is not active!');
        }
    }

    openNotificationSettings = () => {
        if (window.cordova && window.cordova.plugins.diagnostic) {
            window.cordova.plugins.diagnostic.switchToNotificationSettings();
            this.props.errorClose();
        } else {
            console.log('failed to open notification settings!');
        }
    }

    componentDidUpdate(prevProps){
        /*if(prevProps.overlay !== this.props.overlay){
            if(this.props.overlay === "success"){
                setTimeout(() => {
                    this.props.close();
                },2000)
            }
        }*/
    }

    render(){
        const {t} = this.props
        return(
            this.props.overlay === "success" ? 
            
            <section className="overlay">
                <div className="overlay-window-container">
                    <div className="overlay-window no-bg success">
                        <div className="overlay-content">
                            <div className="header">
                                <div className="header-icon">
                                    <i className="fas fa-check"></i>
                                    <p>{t('door_key.door_key_success')}</p>
                                </div>
                                <div className="header-text">
                                    <h3>{this.props.message}</h3>
                                </div>
                            </div>
                            {/* <div className="hotel-logo">
                                {this.props.message}
                            </div> */}
                        </div>
                        <div className="overlay-controls">
                            <button className="button" onClick = {this.props.close}
                            style = {{
                            backgroundColor:this.props.menuColor.assetBackgroundSelectorColor,
                            color: "#fff"
                        }}>{t('door_key.close')}</button>
                        </div>
                    </div>
                </div>
            </section> 
            
            : this.props.overlay === "attention" ? 
            
            <section className="overlay" xstyle="display: none;">
                <div className="overlay-window-container">
                    <div class="overlay-window no-bg doorkey"> 
                        <div className="overlay-content">
                            <div className="header">
                                <div className="header-icon">
                                    {/* <i className="fas fa-exclamation-circle"></i> */}
                                    <p>{t('door_key.please_wait')}</p>
                                </div>
                                <div className="header-text">
                                    <h3>{ this.props.message ? this.props.message : t('door_key.getting_key')}</h3>
                                </div>
                                <div class="loader-ring margin-top-1">
                                    <img src="layout_2/assests/loader.png" />
                                </div>
                            </div>
                            <div className="hotel-logo">
                            {t('door_key.getting_key_msg')}
                            </div>
                        </div>
                        <div className="overlay-controls">
                            <button className="button" onClick = {this.props.errorClose} 
                            style = {{
                            backgroundColor:this.props.menuColor.assetBackgroundSelectorColor,
                            color: "#fff",
                           
                        }}>{t('door_key.close')}</button>
                        </div>
                    </div>
                </div>
            </section> 
            
            : this.props.overlay === "error" ? <section className="overlay" >
                <div className="overlay-window-container">
                    <div className="overlay-window no-bg error">
                        <div className="overlay-content" style={{padding:"0"}}>
                            <div className="header">
                                <div className="header-icon">
                                    <i className="fas fa-times"></i>
                                    {/* <p>{t('door_key.key_failed')}</p> */}
                                </div>
                                <div className="header-text">
                                    <h3>{!this.props.titleMsg ? t('door_key.something_went_wrong') : this.props.titleMsg}</h3>
                                </div>
                            </div>
                            <div className="hotel-logo">
                                {
                                    this.props.locationErr 
                                    ? <>We are unable to retrieve your location. Please <text style={{textDecoration:'underline'}} onClick={() => this.openSettings()}>Enable location permission</text> for the app from the phone's Settings.</> 
                                    : this.props.bluetoothErr 
                                    ? <>We are unable to access bluetooth. Please <text style={{textDecoration:'underline'}} onClick={() => this.openSettings()}>Enable nearby devices permission</text> for the app from the phone's Settings.</> 
                                    : this.props.notificationErr
                                    ? <>Notification access is disabled. Please <text style={{textDecoration:'underline'}} onClick={() => this.openNotificationSettings()}>Enable notification permissions</text> for this app in your phone's Settings.</> 
                                    : this.props.cameraErr 
                                    ? <>We are unable to access camera. Please <text style={{textDecoration:'underline'}} onClick={() => this.openSettings()}>Enable camera permission</text> for the app from the phone's Settings.</> 
                                    : this.props.message
                                } 
                                {
                                    this.props.locationErr 
                                    ? <p style={{textDecoration:"underline"}} onClick={() => this.openSettings()}>{t('door_key.open_settings')}</p> 
                                    : this.props.bluetoothErr 
                                    ? <p style={{textDecoration:"underline"}} onClick={() => this.openSettings()}>{t('door_key.open_settings')}</p> 
                                    : this.props.notificationErr
                                    ? <p style={{textDecoration:"underline"}} onClick={() => this.openNotificationSettings()}>{t('door_key.open_settings')}</p>
                                    : this.props.cameraErr 
                                    ? <p style={{textDecoration:"underline"}} onClick={() => this.openSettings()}>{t('door_key.open_settings')}</p> 
                                    : null
                                }
                            </div>
                        </div>
                        <div className="overlay-controls">
                            {!this.props.hideTryAgain ? <button className="button secondary" onClick = {this.props.tryAgain}
                             >{t('door_key.try_again')}</button> : null}
                            <button className="button" style = {{
                                backgroundColor:this.props.menuColor.assetBackgroundSelectorColor,
                                color: "#fff"
                            }}
                             onClick = {this.props.errorClose}>{t('door_key.close')}</button>
                        </div>
                    </div>
                </div>
            </section> :
            this.props.overlay === "blank" ?   
            <section className="overlay" >
                <div className="overlay-window-container">
                    <div className="overlay-window no-bg doorkey">
                        <div className="overlay-content" style={{padding:"0"}}>
                            <div className="header">
                                <div className="header-icon">
                                    {/* <i className="fas fa-times"></i>
                                    <p>Digital Key Failed</p> */}
                                </div>
                                <div className="header-text">
                                    {/* <h3>{!this.props.titleMsg ? "Something went wrong" : this.props.titleMsg}</h3> */}
                                </div>
                            </div>
                            <div className="hotel-logo">
                                {/* {this.props.message} {this.props.locationErr ? <p onClick={this.openSettings}>Open settings</p> : null} */}
                            </div>
                        </div>
                        <div className="overlay-controls">
                            
                        </div> 
                    </div>
                </div>
            </section>
             : this.props.overlay == "timeout" ? 
             <section className="overlay" xstyle="display: none;">
             <div className="overlay-window-container">
                 <div class="overlay-window no-bg doorkey"> 
                     <div className="overlay-content">
                         <div className="header">
                             <div className="header-icon">
                                 <i className="fas fa-exclamation-circle"></i>
                                 <p>timeout</p>
                             </div>
                             <div className="header-text">
                                 <h3>Door unlock timeout</h3>
                             </div>
                         </div>
                         <div className="hotel-logo">
                             {t('door_key.instructions_on_timeout')}
                         </div>
                     </div>
                     <div className="overlay-controls">
                         <button className="button" onClick = {this.props.errorClose} 
                         style = {{
                         backgroundColor:this.props.menuColor.assetBackgroundSelectorColor,
                         color: "#fff",
                        
                     }}>{t('door_key.close')}</button>
                     </div>
                 </div>
             </div>
         </section> : null
        );
    }
}

const mapStateToProps = state => {
    return{
        menuColor: state.store.home.MenuColor,
       
    }
}

export default connect(
    mapStateToProps, {
    setMobileOverlayState
})(withTranslation('translations')(MobileKeyOverlay));